// extracted by mini-css-extract-plugin
export var readonly = "_jd-1";
export var star = "_jd-0";